module.exports = __webpack_public_path__ + "static/img/irole.a53c1c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/yjyx/irole.png
// module id = Wos5
// module chunks = 7